import { createContext, useContext } from 'react';
import useSilentWitness from '../hooks/useSilentWitness';

const SilentWitnessContext = createContext(null);

export const SilentWitnessProvider = ({ children, onClose }) => {
  const silentWitnessValues = useSilentWitness({ onClose });

  return (
    <SilentWitnessContext.Provider value={silentWitnessValues}>
      {children}
    </SilentWitnessContext.Provider>
  );
};

export const useSilentWitnessContext = () => {
  const context = useContext(SilentWitnessContext);

  if (!context) {
    throw new Error('useSilentWitnessContext must be used within SilentWitnessProvider');
  }

  return context;
};
